import React, { useState, useEffect } from "react";
import "../../generalPages/generalCSS/home.css";
import "../commanComponents/componentCSS/propertylist.css";
import "../commanComponents/componentCSS/transaction.css";
import "bootstrap/dist/css/bootstrap.min.css";
import LazyLoad from "react-lazy-load";
import config from "../../config";
import {
    Row,
    Col,
    Container,
    Card,
    InputGroup,
    Form,
    Button,
    Spinner
} from "react-bootstrap";
import "../commanComponents/componentCSS/listingproperty.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../commanComponents/componentCSS/swiper.css";
import { Pagination } from "swiper/modules";
import { IoClose } from "react-icons/io5";
import { getHotelSearchResults, getNextHotelResults, getHotelContent } from "../../Action/user.action";

import { useNavigate, useLocation, useParams } from 'react-router-dom';
import slugify from "slugify";

const aminities = [
    { id: 1, name: "WiFi" },
    { id: 2, name: "Pool" },
    { id: 3, name: "Kitchen" },
    { id: 4, name: "Parking" },
    { id: 5, name: "AC" }
];

const ZenPropertyList = () => {
    const [originalListings, setOriginalListings] = useState([]);
    const [filteredListings, setFilteredListings] = useState([]);
    const [displayedListings, setDisplayedListings] = useState([]);
    const [searchHoteltext, setSearchHoteltext] = useState("");
    const [noofrating, setNoofrating] = useState(null);
    const [minprice, setMinprice] = useState(0);
    const [maxprice, setMaxprice] = useState(1000);
    const [propertyPurchaseTypeId] = useState(2);
    const [currency] = useState("USD");
    const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
    const [selectedAmenities, setSelectedAmenities] = useState([]);
    const [itemsToShow, setItemsToShow] = useState(10);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const {
        searchLocation,
        numberOfAdults,
        checkin,
        checkout,
    } = useParams();

    // Fetch data
    useEffect(() => {
        fetchHotelData();
    }, [token]);

    const fetchHotelData = async () => {
        if (!token) {
            setIsLoading(false);
            setHasError(true);
            return;
        }

        try {
            setIsLoading(true);
            setHasError(false);

            const res = await getHotelSearchResults({ token: token });
            let hotelResults = res?.data || {};

            if (hotelResults?.status == "InProgress" && !hotelResults.nextResultsKey) {
                fetchHotelData()
            }

            if (hotelResults?.status == "InProgress") {
                const res = await getNextHotelResults({ token: token, nextResultsKey: hotelResults.nextResultsKey });
                const nextHotelResults = res?.data || {};
                if (nextHotelResults?.hotels?.length > 0) {
                    hotelResults.hotels = [...(hotelResults.hotels || []), ...(nextHotelResults.hotels || [])];
                } else {
                    console.error('Error fetching next hotel results:', nextHotelResults);
                }
            }



            if (hotelResults?.hotels?.length > 0) {
                const ratesMap = new Map();
                hotelResults.hotels.forEach(hotel => {
                    ratesMap.set(hotel.id, {
                        totalRate: hotel.rate?.totalRate || 0,
                        baseRate: hotel.rate?.baseRate || 0,
                        taxes: hotel.rate?.taxes || 0,
                        cancellationPolicy: hotel.rate?.cancellationPolicy || [],
                        freeCancellation: hotel.options?.freeCancellation || false
                    });
                });

                const hotelIds = hotelResults.hotels.map(hotel => hotel.id);
                const res = await getHotelContent({ hotelIds: hotelIds });
                const hotelContent = res?.data || {};

                if (hotelContent?.hotels?.length > 0) {
                    const hotelsWithImages = hotelContent.hotels.filter(content => content.heroImage);

                    const transformedListings = hotelsWithImages.map(content => {
                        const rateInfo = ratesMap.get(content.id) || {};

                        return {
                            id: content.id,
                            propertyName: content.name,
                            location: `${content.contact?.address?.city?.name || 'Unknown City'}, ${content.contact?.address?.country?.name || 'Unknown Country'}`,
                            price: rateInfo.totalRate || 0,
                            PropertyType: content.category || "Hotel",
                            rating: parseFloat(content.starRating) || 0,
                            imageArr: JSON.stringify([
                                {
                                    fileNameImage: content.heroImage
                                }
                            ]),
                            address: content.contact?.address?.line1 || '',
                            city: content.contact?.address?.city?.name || '',
                            country: content.contact?.address?.country?.name || '',
                            starRating: content.starRating || '0',
                            coordinates: content.geoCode ? {
                                lat: parseFloat(content.geoCode.lat),
                                lng: parseFloat(content.geoCode.long)
                            } : null,
                        };
                    });

                    const maxPrice = Math.max(...transformedListings.map(item => item.price), 1000);
                    setHasError(false);
                    setOriginalListings(transformedListings);
                    setFilteredListings(transformedListings);
                    setMaxprice(maxPrice);
                    setDisplayedListings(transformedListings.slice(0, 10)); // Show first 10 items initially
                } else {
                    setHasError(true);
                }

            } else {
                setHasError(true);
            }
        } catch (err) {
            console.error('Error fetching hotel data:', err);
            setHasError(true);
        } finally {
            setIsLoading(false);
        }
    };

    // Apply filters
    useEffect(() => {
        let results = [...originalListings];

        // Search filter
        if (searchHoteltext) {
            results = results.filter(item =>
                item.propertyName.toLowerCase().includes(searchHoteltext.toLowerCase()) ||
                item.location.toLowerCase().includes(searchHoteltext.toLowerCase())
            );
        }

        // Price filter
        results = results.filter(item =>
            item.price >= minprice && item.price <= maxprice
        );

        // Rating filter
        if (noofrating) {
            results = results.filter(item =>
                Math.floor(item.rating) === noofrating
            );
        }

        // Property type filter
        if (selectedPropertyTypes.length > 0) {
            results = results.filter(item =>
                selectedPropertyTypes.includes(item.PropertyType)
            );
        }

        // Amenities filter
        if (selectedAmenities.length > 0) {
            results = results.filter(item => {
                return selectedAmenities.every(amenity => {
                    switch (amenity) {
                        case "WiFi": return item.hasWiFi;
                        case "Pool": return item.hasPool;
                        case "Parking": return item.hasParking;
                        case "AC": return item.hasAC;
                        default: return true;
                    }
                });
            });
        }

        setFilteredListings(results);
        setItemsToShow(10); // Reset to showing 10 items when filters change
    }, [searchHoteltext, minprice, maxprice, noofrating, selectedPropertyTypes, selectedAmenities, originalListings]);

    // Load more items
    const loadMore = () => {
        setItemsToShow(prev => prev + 10);
    };

    // Filter handlers
    const clearAllFilters = () => {
        setSearchHoteltext("");
        setMinprice(0);
        setMaxprice(Math.max(...originalListings.map(item => item.price), 1000));
        setNoofrating(null);
        setSelectedPropertyTypes([]);
        setSelectedAmenities([]);
    };

    const selectRatingsFilter = (e, rating) => {
        setNoofrating(noofrating === rating ? null : rating);
    };

    const selectPropertyTypeFilter = (e, type) => {
        setSelectedPropertyTypes(prev =>
            prev.includes(type)
                ? prev.filter(t => t !== type)
                : [...prev, type]
        );
    };

    // const selectAminitiesFilter = (e, amenity) => {
    //     setSelectedAmenities(prev =>
    //         prev.includes(amenity)
    //             ? prev.filter(a => a !== amenity)
    //             : [...prev, amenity]
    //     );
    // };

    const selectPricerangeCheckBox = (e, min, max) => {
        setMinprice(min);
        setMaxprice(max);
    };

    const priceFilterInput = (e) => {
        // This can be implemented if you want live range filtering
    };

    const applyPriceRangeFilter = () => {
        // Already applied live through useEffect
    };

    const redirectToDetailPage = (e, id, name) => {
        e.preventDefault();
        console.log(`Redirecting to property ${id}: ${name}`);
    };

    const addToWishList = (e, id, status, action) => {
        e.stopPropagation();
        console.log(`Wishlist action for property ${id}: status ${status}, action ${action}`);
    };

    const convertPrice = (price) => {
        return parseFloat(price).toFixed(2);
    };

    return (
        <section className="propertylist">
            <Container>
                <Row>
                    <Col lg={4} className="mb-5">
                        <div className="filter-area position-relative">
                            <Card className="p-0">
                                <div className="filter-head">
                                    <h6 className="mb-0">
                                        <b>Filter By:</b>
                                        <span
                                            style={{ float: "right", cursor: "pointer" }}
                                            onClick={clearAllFilters}
                                        >
                                            Clear all
                                        </span>
                                    </h6>
                                </div>

                                {/* Search Filter */}
                                <div className="searchfield px-4 mt-3">
                                    <InputGroup className="">
                                        <Form.Control
                                            aria-label="Example text with button addon"
                                            aria-describedby="basic-addon1"
                                            placeholder="Search by property name"
                                            value={searchHoteltext}
                                            onChange={(e) => setSearchHoteltext(e.target.value)}
                                        />
                                        {searchHoteltext.length > 0 ? (
                                            <Button
                                                variant="default"
                                                id="button-addon1"
                                                className="border-0"
                                                onClick={() => setSearchHoteltext("")}
                                            >
                                                <IoClose fill="#838383" />
                                            </Button>
                                        ) : (
                                            <Button
                                                variant="default"
                                                id="button-addon1"
                                                className="border-0"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="18"
                                                    height="19"
                                                    viewBox="0 0 18 19"
                                                    fill="none"
                                                >
                                                    <ellipse
                                                        cx="8.16667"
                                                        cy="8.16667"
                                                        rx="6.66667"
                                                        ry="6.66667"
                                                        stroke="#838383"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M12.75 13.1318L16.9167 17.2985"
                                                        stroke="#838383"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </Button>
                                        )}
                                    </InputGroup>
                                </div>

                                {/* Price Filter */}
                                <div className="filter-list">
                                    <p className="mb-0">
                                        <b>Price</b>
                                    </p>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="rangeslider mt-2">
                                                <div className="d-flex justify-content-between small text-grey mb-2">
                                                    <span>${minprice}</span>
                                                    <span>${maxprice}</span>
                                                </div>
                                                <input
                                                    type="range"
                                                    min="0"
                                                    max={Math.max(...originalListings.map(item => item.price), 1000)}
                                                    value={minprice}
                                                    onChange={(e) => setMinprice(parseInt(e.target.value))}
                                                    className="form-range mb-3"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12 text-right mt-2">
                                            <button
                                                className="btn btn-sm btn-primary rounded-5 px-4 h-auto"
                                                onClick={applyPriceRangeFilter}
                                            >
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                    <div className="listcheckbox mt-3">
                                        <Form>
                                            {["checkbox"].map((type) => (
                                                <div key={`inline-${type}`} className="mb-3">
                                                    <Form.Check
                                                        label="Under $50"
                                                        name="group1"
                                                        onChange={(e) => selectPricerangeCheckBox(e, 0, 50)}
                                                        checked={minprice === 0 && maxprice === 50}
                                                        className="mt-2 w-50 mr-0 d-sm-inline-flex"
                                                        type={type}
                                                        id={`inline-${type}-1`}
                                                    />
                                                    <Form.Check
                                                        label="$101 - $150"
                                                        name="group1"
                                                        onChange={(e) => selectPricerangeCheckBox(e, 101, 150)}
                                                        checked={minprice === 101 && maxprice === 150}
                                                        className="mt-2 w-50 mr-0 d-sm-inline-flex"
                                                        type={type}
                                                        id={`inline-${type}-2`}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="$51 - $100"
                                                        onChange={(e) => selectPricerangeCheckBox(e, 51, 100)}
                                                        checked={minprice === 51 && maxprice === 100}
                                                        type={type}
                                                        className="mt-2 w-50 mr-0 d-sm-inline-flex"
                                                        id={`inline-${type}-3`}
                                                    />
                                                    <Form.Check
                                                        label="Above $150"
                                                        name="group1"
                                                        className="mt-2 w-50 mr-0 d-sm-inline-flex"
                                                        onChange={(e) => selectPricerangeCheckBox(e, 151, 10000000000)}
                                                        checked={minprice === 151 && maxprice === 10000000000}
                                                        type={type}
                                                        id={`inline-${type}-1`}
                                                    />
                                                </div>
                                            ))}
                                        </Form>
                                    </div>
                                </div>

                                {/* Rating Filter */}
                                <div className="filter-list">
                                    <p className="mb-0">
                                        <b>Rating</b>
                                    </p>
                                    <div className="listcheckbox">
                                        <Form>
                                            {["checkbox"].map((type) => (
                                                <div key={`inline-${type}`} className="mb-3">
                                                    <Form.Check
                                                        label="2 Star"
                                                        value={2}
                                                        onChange={(e) => selectRatingsFilter(e, 2)}
                                                        checked={noofrating === 2}
                                                        name="group1"
                                                        className="mt-2 w-50 mr-0 d-sm-inline-flex"
                                                        type={type}
                                                        id={`inline-${type}-1`}
                                                    />
                                                    <Form.Check
                                                        label="4 Star"
                                                        name="group1"
                                                        value={4}
                                                        onChange={(e) => selectRatingsFilter(e, 4)}
                                                        checked={noofrating === 4}
                                                        className="mt-2 w-50 mr-0 d-sm-inline-flex"
                                                        type={type}
                                                        id={`inline-${type}-2`}
                                                    />
                                                    <Form.Check
                                                        label="3 Star"
                                                        value={3}
                                                        onChange={(e) => selectRatingsFilter(e, 3)}
                                                        checked={noofrating === 3}
                                                        type={type}
                                                        className="mt-2 w-50 mr-0 d-sm-inline-flex"
                                                        id={`inline-${type}-3`}
                                                    />
                                                    <Form.Check
                                                        label="5 Star"
                                                        name="group1"
                                                        value={5}
                                                        onChange={(e) => selectRatingsFilter(e, 5)}
                                                        checked={noofrating === 5}
                                                        className="mt-2 w-50 mr-0 d-sm-inline-flex"
                                                        type={type}
                                                        id={`inline-${type}-1`}
                                                    />
                                                </div>
                                            ))}
                                        </Form>
                                    </div>
                                </div>

                                {/* Amenities Filter */}
                                {/* <div className="filter-list">
                                    <p className="mb-0">
                                        <b>Amenities</b>
                                    </p>
                                    <div className="listcheckbox">
                                        <Form>
                                            <div key={`inline-checkbox`} className="mb-3">
                                                {aminities.map((item) => (
                                                    <Form.Check
                                                        label={item.name}
                                                        name="propertyAmenityIds"
                                                        value={item.id}
                                                        onChange={(e) => selectAminitiesFilter(e, item.name)}
                                                        checked={selectedAmenities.includes(item.name)}
                                                        className="mt-2 mr-0 d-sm-inline-flex w-50"
                                                        type="checkbox"
                                                        id={`inline-amenity-${item.id}`}
                                                    />
                                                ))}
                                            </div>
                                        </Form>
                                    </div>
                                </div> */}
                            </Card>
                        </div>
                    </Col>

                    <Col lg={8}>
                        <div className="propertylist-area">
                            <Row>
                                {console.log('filteredListings.length', hasError, filteredListings.length)
                                }
                                {isLoading ? (
                                    <Col lg={12} className="text-center my-5">
                                        <div className="loader-container" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                            <img
                                                src="assets/images/loader-home.gif"
                                                style={{ height: "100px", width: "100px" }}
                                                alt="Loading..."
                                            />
                                            <p className="mt-2 mb-0">Loading hotels...</p>
                                        </div>
                                    </Col>

                                ) : hasError || filteredListings.length === 0 ? (
                                    <Col lg={12} className="mb-4">
                                        <div className="propertybox p-5 text-center border rounded-2">
                                            <h5>Oops! We couldn't find a perfect match for your search at this time. Don't worry, our friendly team is here to help you discover an ideal place for your stay.</h5>
                                            <p className="mt-2">
                                                Reach out to us, and we'll make it happen!
                                            </p>
                                            <div className="d-flex flex-column align-items-center mt-3">
                                                <img
                                                    src="/images/icon/customer-service.png"
                                                    alt="Support"
                                                    style={{ width: '60px', height: '60px', marginBottom: '10px' }}
                                                />
                                                <Button
                                                    variant="primary"
                                                    href={`/contactus`}
                                                >
                                                    Contact Us
                                                </Button>
                                            </div>

                                        </div>
                                    </Col>


                                ) : (
                                    <>
                                        {filteredListings.slice(0, itemsToShow).map((item) => (
                                            <Col lg={6} className="mb-4" key={item.id}>
                                                <div className="propertybox"
                                                    onClick={() => navigate(`/zenpropertydetail/${slugify(item.propertyName, { lower: true, strict: true })}/${item.id}/${checkin}/${checkout}?token=${token}`)}
                                                    style={{ cursor: 'pointer' }} >
                                                    <Swiper
                                                        pagination={{ dynamicBullets: true }}
                                                        modules={[Pagination]}
                                                        className="mySwiper"
                                                    >
                                                        <div className="overflow-hidden property-img">
                                                            <SwiperSlide>
                                                                {item.imageArr && JSON.parse(item.imageArr).length > 0 ? (
                                                                    <LazyLoad width={416}>
                                                                        <img
                                                                            src={JSON.parse(item.imageArr)[0].fileNameImage}
                                                                            className="img-fluid"
                                                                            alt={item.propertyName}
                                                                        />
                                                                    </LazyLoad>
                                                                ) : null}
                                                            </SwiperSlide>
                                                        </div>
                                                        <div className="heart-icon">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                onClick={(e) => addToWishList(e, item.id, 1, 1)}
                                                                width="22"
                                                                height="19"
                                                                viewBox="0 0 22 19"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M22 6.63233C21.8905 2.93562 18.9353 0 15.2139 0C14.0099 0 12.1493 0.869814 11.3831 2.28326C11.2736 2.60944 10.8358 2.60944 10.7264 2.28326C9.85075 0.978541 8.0995 0.108727 6.78607 0.108727C3.17413 0.108727 0.109453 3.04435 0 6.63233V6.84979C0 8.69814 0.766169 10.4378 2.0796 11.7425C2.0796 11.7425 2.0796 11.7425 2.0796 11.8512C2.18905 11.9599 7.44279 16.5265 9.85075 18.5923C10.5075 19.1359 11.4925 19.1359 12.1493 18.5923C14.5572 16.5265 19.7015 11.9599 19.9204 11.8512C19.9204 11.8512 19.9204 11.8512 19.9204 11.7425C21.2338 10.5465 22 8.80687 22 6.84979V6.63233Z"
                                                                    fill="white"
                                                                    fillOpacity="0.7"
                                                                />
                                                            </svg>
                                                        </div>
                                                    </Swiper>

                                                    <Row className="mt-2">
                                                        <Col lg={8} sm={8} xs={8}>
                                                            <h6>
                                                                <b>
                                                                    {item?.propertyName?.length > 20
                                                                        ? `${item?.propertyName.slice(0, 20)}...`
                                                                        : item?.propertyName}
                                                                </b>
                                                            </h6>
                                                        </Col>
                                                        <Col lg={4} sm={4} xs={4} className="text-right">
                                                            <span className="text-grey">
                                                                {item.PropertyType}
                                                            </span>
                                                        </Col>
                                                        <Col lg={8} sm={8} xs={8}>
                                                            <p className="small text-grey">
                                                                {item.location?.length > 25
                                                                    ? `${item.location.slice(0, 15)}...`
                                                                    : item.location}
                                                            </p>
                                                        </Col>
                                                        <Col lg={4} sm={4} xs={4} className="text-right">
                                                            <p style={{ color: "#FFB800" }} className="small fw-bold d-flex justify-content-end align-items-center">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="17"
                                                                    height="16"
                                                                    viewBox="0 0 17 16"
                                                                    fill="none"
                                                                >
                                                                    <path
                                                                        d="M8.37531 0L10.2596 5.87336L16.3575 5.87336L11.4242 9.50329L13.3086 15.3766L8.37531 11.7467L3.44206 15.3766L5.32639 9.50329L0.393141 5.87336L6.49097 5.87336L8.37531 0Z"
                                                                        fill="#FFB800"
                                                                    />
                                                                </svg>
                                                                &nbsp;
                                                                {item.rating == 0
                                                                    ? "0"
                                                                    : parseFloat(item.rating).toFixed(1)}
                                                                {item.ratingArr == null
                                                                    ? "(0)"
                                                                    : `(${JSON.parse(item.ratingArr).length})`}
                                                            </p>
                                                        </Col>
                                                        <Col lg={8} sm={8} xs={8}>
                                                            <small>
                                                                <a href="#" className="text-decoration-none fw-bold">
                                                                    $ {convertPrice(item.price ? item.price : '0.00')} {currency}
                                                                    {" "}
                                                                    {propertyPurchaseTypeId == 2 ? "/ Night" : ""}
                                                                </a>
                                                                {item.freeCancellation && (
                                                                    <span className="badge bg-success ms-2 small">
                                                                        Free Cancellation
                                                                    </span>
                                                                )}
                                                            </small>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        ))}

                                        {/* Load More Button */}
                                        {itemsToShow < filteredListings.length && (
                                            <Col lg={12} className="text-center mt-4">
                                                <Button
                                                    variant="primary"
                                                    onClick={loadMore}
                                                    className="px-4 py-2"
                                                >
                                                    Load More
                                                </Button>
                                            </Col>
                                        )}
                                    </>
                                )}
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ZenPropertyList;